import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "react-hot-toast";
import { Web3Provider } from "./providers/Web3Provider";
import { Layout } from "./components/Layout";
import { LandingPage } from "./pages/LandingPage";
import { SwapPage } from "./components/swap/SwapPage";
import { LiquidityPage } from "./components/liquidity/LiquidityPage";
import { LaunchpadPage } from "./components/launchpad/LaunchpadPage";
import { LaunchForm } from "./components/launchpad/LaunchForm";
import { TokenDashboard } from "./components/launchpad/TokenDashboard";
import { FarmsPage } from "./pages/FarmsPage";
import { BridgePage } from "./pages/BridgePage";
import { CollectionStationPage } from "./pages/CollectionStationPage";
import { PoolsPage } from "./pages/PoolsPage";
import { TokenClonerPage } from "./pages/TokenClonerPage";
import { VePage } from "./pages/VePage";
import { AnalyticsPage } from "./pages/AnalyticsPage";
import { RewardsPage } from "./pages/RewardsPage";
import { PoolCreatorPage } from "./pages/PoolCreatorPage";

export default function App() {
  return (
    <Web3Provider>
      <BrowserRouter>
        <Layout>
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/swap" element={<SwapPage />} />
            <Route path="/liquidity" element={<LiquidityPage />} />
            <Route path="/launchpad" element={<LaunchpadPage />} />
            <Route path="/launchpad/launch" element={<LaunchForm />} />
            <Route path="/launchpad/token/:address" element={<TokenDashboard />} />
            <Route path="/farms" element={<FarmsPage />} />
            <Route path="/bridge" element={<BridgePage />} />
            <Route path="/collection-station" element={<CollectionStationPage />} />
            <Route path="/pools" element={<PoolsPage />} />
            <Route path="/token-cloner" element={<TokenClonerPage />} />
            <Route path="/ve" element={<VePage />} />
            <Route path="/analytics" element={<AnalyticsPage />} />
            <Route path="/rewards" element={<RewardsPage />} />
            <Route path="/create-pool" element={<PoolCreatorPage />} />
          </Routes>
        </Layout>
      </BrowserRouter>
      <Toaster
        position="bottom-right"
        toastOptions={{
          style: {
            background: "rgba(8,10,16,0.97)",
            color: "#EAF6F8",
            border: "1px solid rgba(57,230,255,0.15)",
            borderRadius: "12px",
            fontSize: "14px",
          },
          success: {
            iconTheme: {
              primary: "#39E6FF",
              secondary: "#050708",
            },
          },
          error: {
            iconTheme: {
              primary: "#ef4444",
              secondary: "#050708",
            },
          },
        }}
      />
    </Web3Provider>
  );
}
